module.exports = __webpack_public_path__ + "static/img/demo_2_and.4b9f0e65.png";